import _ from 'lodash'
import SVG from 'svg.js'
import Flatten from 'flatten-js'
import i18n from '@/i18n.js'

import { workflow_grid_step, workflow_brick_size } from '@/utils.js'

// import { bricks_infos } from '@/components/bricks_infos.js'
import { brick_info_from_name } from '@/components/bricks_infos_core.js'
import '@/components/bricks_infos.js'

// *****************************************************************************

let point = Flatten.point
let Polygon = Flatten.Polygon

export const workflow_nb_bricks_in_palette = 16

// Position relative to brick center
// (brick position fields tracks the center of the brick)
// Position is where the connector must depart / arrive from / to
export const brick_port_endpoint_positions = {
  none: { x: 0, y: 0 },
  tl: {
    x: 0 - workflow_brick_size / 2,
    y: (workflow_grid_step * 3) / 2 - workflow_brick_size / 2,
  },
  ml: {
    x: 0 - workflow_brick_size / 2,
    y: (workflow_grid_step * 5) / 2 - workflow_brick_size / 2,
  },
  bl: {
    x: 0 - workflow_brick_size / 2,
    y: (workflow_grid_step * 7) / 2 - workflow_brick_size / 2,
  },
  tr: {
    x: workflow_brick_size - 1 - workflow_brick_size / 2,
    y: (workflow_grid_step * 3) / 2 - workflow_brick_size / 2,
  },
  mr: {
    x: workflow_brick_size - 1 - workflow_brick_size / 2,
    y: (workflow_grid_step * 5) / 2 - workflow_brick_size / 2,
  },
  br: {
    x: workflow_brick_size - 1 - workflow_brick_size / 2,
    y: (workflow_grid_step * 7) / 2 - workflow_brick_size / 2,
  },
}

// Position is top left corner of port
export const brick_port_point_topleft_positions = {
  none: { x: 0, y: 0 },
  tl: {
    x: 0 - workflow_brick_size / 2,
    y: workflow_grid_step - workflow_brick_size / 2,
  },
  ml: {
    x: 0 - workflow_brick_size / 2,
    y: workflow_grid_step * 2 - workflow_brick_size / 2,
  },
  bl: {
    x: 0 - workflow_brick_size / 2,
    y: workflow_grid_step * 3 - workflow_brick_size / 2,
  },
  tr: {
    x: workflow_brick_size - workflow_grid_step - workflow_brick_size / 2,
    y: workflow_grid_step - workflow_brick_size / 2,
  },
  mr: {
    x: workflow_brick_size - workflow_grid_step - workflow_brick_size / 2,
    y: workflow_grid_step * 2 - workflow_brick_size / 2,
  },
  br: {
    x: workflow_brick_size - workflow_grid_step - workflow_brick_size / 2,
    y: workflow_grid_step * 3 - workflow_brick_size / 2,
  },
}

export function brick_port_box(brick_coordinates, position) {
  const offset = brick_port_point_topleft_positions[position]
  const res = new Flatten.Box(
    brick_coordinates.x + offset.x,
    brick_coordinates.y + offset.y,
    brick_coordinates.x + offset.x + workflow_grid_step,
    brick_coordinates.y + offset.y + workflow_grid_step
  )
  return res
}

function select_icon_arrow_classes(is_left, is_selected) {
  let classes = ['arrowhead']
  if (is_selected) {
    classes.push('text-green')
  } else {
    classes.push('text-blue')
  }
  return classes
}

function select_icon_text_arrow_classes(is_left, is_selected) {
  let classes = ['arrowrighttextcontainer', 'text-white']
  if (is_selected) {
    classes.push('bg-green')
  } else {
    classes.push('bg-blue')
  }
  return classes
}

function create_icons(defs, selection) {
  let res = undefined

  if (_.isUndefined(defs) || _.isEmpty(defs)) {
    res = {}
  } else {
    let back_classes = _.clone(defs.back_classes)
    back_classes.push(`synaplus-cosmo-glow-text-${defs.background_color}`)
    res = {
      tlarrow: defs.input[0] != ' ',
      mlarrow: defs.input[1] != ' ',
      blarrow: defs.input[2] != ' ',
      tlletter: defs.input[0],
      mlletter: defs.input[1],
      blletter: defs.input[2],

      trarrow: defs.output[0] != ' ',
      mrarrow: defs.output[1] != ' ',
      brarrow: defs.output[2] != ' ',
      trletter: defs.output[0],
      mrletter: defs.output[1],
      brletter: defs.output[2],

      paletteiconbackclasses: defs.back_classes,
      iconbackclasses: back_classes,
      iconfrontclasses: defs.front_classes,

      tlarrowclasses: select_icon_arrow_classes(true, selection & 1),
      tlarrowtextclasses: select_icon_text_arrow_classes(true, selection & 1),
      mlarrowclasses: select_icon_arrow_classes(true, selection & 2),
      mlarrowtextclasses: select_icon_text_arrow_classes(true, selection & 2),
      blarrowclasses: select_icon_arrow_classes(true, selection & 4),
      blarrowtextclasses: select_icon_text_arrow_classes(true, selection & 4),
      trarrowclasses: select_icon_arrow_classes(false, selection & 8),
      trarrowtextclasses: select_icon_text_arrow_classes(false, selection & 8),
      mrarrowclasses: select_icon_arrow_classes(false, selection & 16),
      mrarrowtextclasses: select_icon_text_arrow_classes(false, selection & 16),
      brarrowclasses: select_icon_arrow_classes(false, selection & 32),
      brarrowtextclasses: select_icon_text_arrow_classes(false, selection & 32),

      background_color: defs.background_color,
    }
  }
  return res
}

// export const corr = {
//   none: {
//     input: '   ',
//     output: '   ',
//     back_classes: [],
//     front_classes: [],
//     name: 'none',
//     short_tooltip_description: '',
//     full_tooltip_description: '',
//     background_color: '',
//   },
//   modify: {
//     input: '   ',
//     output: '   ',
//     back_classes: ['far', 'fa-square', 'text-blue'],
//     front_classes: ['fas', 'fa-cog', 'text-blue'],
//     name: 'modify',
//     short_tooltip_description: 'modify_short_tooltip',
//     full_tooltip_description: 'modify_full_tooltip',
//     navbar_name: 'modify_navbar',
//     background_color: 'blue',
//   },
//   delete: {
//     input: '   ',
//     output: '   ',
//     back_classes: ['far', 'fa-octagon', 'text-red'],
//     front_classes: ['fas', 'fa-trash-alt', 'text-red'],
//     name: 'cancel',
//     short_tooltip_description: 'delete_short_tooltip',
//     full_tooltip_description: 'delete_full_tooltip',
//     navbar_name: 'delete_navbar',
//     background_color: 'red',
//   },
//   cancel: {
//     input: '   ',
//     output: '   ',
//     back_classes: ['far', 'fa-circle', 'text-blue'],
//     front_classes: ['fas', 'fa-ban', 'text-blue'],
//     name: 'cancel',
//     short_tooltip_description: 'cancel_short_tooltip',
//     full_tooltip_description: 'cancel_full_tooltip',
//     navbar_name: 'cancel_navbar',
//     background_color: 'blue',
//   },
//   vstack: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-square', 'text-green'],
//     front_classes: ['fas', 'fa-layer-group', 'text-white'],
//     name: 'vstack',
//     associated_class_name: 'AutomlVstackTable',
//     editing_component: 'BrickVstack',
//     summary_component: 'SummaryDefault',
//     short_tooltip_description: 'vstack_short_tooltip',
//     full_tooltip_description: 'vstack_full_tooltip',
//     navbar_name: 'vstack_navbar',
//     background_color: 'green',
//   },
//   hstack: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-square', 'text-green'],
//     front_classes: ['fas', 'fa-layer-group', 'fa-rotate-270', 'text-white'],
//     name: 'hstack',
//     associated_class_name: 'AutomlHstackTable',
//     editing_component: 'BrickHstack',
//     summary_component: 'SummaryDefault',
//     short_tooltip_description: 'hstack_short_tooltip',
//     full_tooltip_description: 'hstack_full_tooltip',
//     navbar_name: 'hstack_navbar',
//     background_color: 'green',
//   },
//   history: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-square', 'text-green'],
//     front_classes: ['fas', 'fa-clock', 'text-white'],
//     name: 'history',
//     associated_class_name: 'AutomlHistoryTable',
//     editing_component: 'BrickHistory',
//     summary_component: 'SummaryDefault',
//     short_tooltip_description: 'history_short_tooltip',
//     full_tooltip_description: 'history_full_tooltip',
//     navbar_name: 'history_navbar',
//     background_color: 'green',
//   },
//   unique: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-square', 'text-red'],
//     front_classes: ['fas', 'fa-divide', 'text-white'],
//     name: 'unique',
//     associated_class_name: 'AutomlUnique',
//     editing_component: 'BrickUnique',
//     summary_component: 'SummaryDefault',
//     short_tooltip_description: 'unique_short_tooltip',
//     full_tooltip_description: 'unique_full_tooltip',
//     navbar_name: 'unique_navbar',
//     background_color: 'red',
//   },
//   filter: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-circle', 'text-orange'],
//     front_classes: ['fas', 'fa-filter', 'text-white'],
//     name: 'filter',
//     associated_class_name: 'AutomlFilter',
//     editing_component: 'BrickFilter',
//     summary_component: 'SummaryDefault',
//     short_tooltip_description: 'filter_short_tooltip',
//     full_tooltip_description: 'filter_full_tooltip',
//     navbar_name: 'filter_navbar',
//     background_color: 'orange',
//   },
//   manualfe: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-circle', 'text-orange'],
//     front_classes: ['fas', 'fa-hand-paper', 'text-white'],
//     name: 'manualfe',
//     associated_class_name: 'AutomlManualFeatureEngineeredTable',
//     editing_component: 'BrickManualFeatureEngineering',
//     summary_component: 'SummaryDefault',
//     short_tooltip_description: 'manualfe_short_tooltip',
//     full_tooltip_description: 'manualfe_full_tooltip',
//     navbar_name: 'manualfe_navbar',
//     background_color: 'orange',
//   },
//   historyfe: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-circle', 'text-orange'],
//     front_classes: ['fas', 'fa-history', 'text-white'],
//     name: 'historyfe',
//     associated_class_name: 'AutomlHistoryFeatureEngineeredTable',
//     navbar_name: 'FE historique',
//     editing_component: 'BrickHistoryFeatureEngineering',
//     summary_component: 'SummaryDefault',
//     short_tooltip_description: "Feature engineering sur l'historique",
//     full_tooltip_description:
//       "Feature engineering automatique sur l'historique",
//     background_color: 'orange',
//   },
//   addid: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-circle', 'text-orange'],
//     front_classes: ['fas', 'fa-id-card', 'text-white'],
//     name: 'addid',
//     associated_class_name: 'AutomlAddIdColumn',
//     editing_component: 'BrickAddIdColumn',
//     summary_component: 'SummaryDefault',
//     short_tooltip_description: 'addid_short_tooltip',
//     full_tooltip_description: 'addid_full_tooltip',
//     navbar_name: 'addid_navbar',
//     background_color: 'orange',
//   },
//   addconst: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-circle', 'text-orange'],
//     front_classes: ['fas', 'fa-dice-one', 'text-white'],
//     name: 'addconst',
//     associated_class_name: 'AutomlAddConstColumn',
//     editing_component: 'BrickAddConstColumn',
//     summary_component: 'SummaryDefault',
//     short_tooltip_description: 'addconst_short_tooltip',
//     full_tooltip_description: 'addconst_full_tooltip',
//     navbar_name: 'addconst_navbar',
//     background_color: 'orange',
//   },
//   colrenamer: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-circle', 'text-orange'],
//     front_classes: ['fas', 'fa-file-signature', 'text-white'],
//     name: 'colrenamer',
//     associated_class_name: 'AutomlColumnsRenamer',
//     editing_component: 'BrickColumnsRenamer',
//     summary_component: 'SummaryDefault',
//     short_tooltip_description: 'colrenamer_short_tooltip',
//     full_tooltip_description: 'colrenamer_full_tooltip',
//     navbar_name: 'colrenamer_navbar',
//     background_color: 'orange',
//   },
//   join: {
//     input: 'LMR',
//     output: ' > ',
//     back_classes: ['fas', 'fa-book-alt', 'text-red'],
//     front_classes: ['fas', 'fa-link', 'text-white'],
//     name: 'join',
//     associated_class_name: 'AutomlJoinTable',
//     short_tooltip_description: 'join_short_tooltip',
//     full_tooltip_description: 'join_full_tooltip',
//     navbar_name: 'join_navbar',
//     background_color: 'red',
//   },
//   pivot: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-book-alt', 'text-red'],
//     front_classes: ['fas', 'fa-retweet-alt', 'text-white'],
//     name: 'pivot',
//     associated_class_name: 'AutomlPivotTable',
//     short_tooltip_description: 'pivot_short_tooltip',
//     full_tooltip_description: 'pivot_full_tooltip',
//     navbar_name: 'pivot_navbar',
//     background_color: 'red',
//   },
//   sourcefile: {
//     input: '   ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-file', 'text-blue'],
//     front_classes: ['fas', 'fa-table', 'text-white'],
//     name: 'sourcefile',
//     associated_class_name: 'AutomlFile',
//     editing_component: 'BrickFile',
//     summary_component: 'SummaryFile',
//     short_tooltip_description: 'sourcefile_short_tooltip',
//     full_tooltip_description: 'sourcefile_full_tooltip',
//     navbar_name: 'sourcefile_navbar',
//     background_color: 'blue',
//   },
//   database: {
//     input: '   ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-file', 'text-blue'],
//     front_classes: ['fas', 'fa-database', 'text-white'],
//     name: 'database',
//     associated_class_name: 'AutomlDatabase',
//     editing_component: 'BrickDatabase',
//     summary_component: 'SummaryDefault',
//     short_tooltip_description: 'database_short_tooltip',
//     full_tooltip_description: 'database_full_tooltip',
//     navbar_name: 'database_navbar',
//     background_color: 'blue',
//   },
//   aggregation: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-hexagon', 'text-red'],
//     front_classes: ['fas', 'fa-share-alt', 'fa-flip-horizontal', 'text-white'],
//     name: 'aggregation',
//     associated_class_name: 'AutomlAggregation',
//     editing_component: 'BrickAggregation',
//     summary_component: 'SummaryDefault',
//     short_tooltip_description: 'aggregation_short_tooltip',
//     full_tooltip_description: 'aggregation_full_tooltip',
//     navbar_name: 'aggregation_navbar',
//     background_color: 'red',
//   },
//   dispatch: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-file', 'text-blue'],
//     front_classes: ['fas', 'fa-arrow-alt-down', 'text-white'],
//     name: 'dispatch',
//     associated_class_name: 'AutomlDispatchTable',
//     summary_component: 'SummaryDispatch',
//     editing_component: 'BrickDispatchTable',
//     short_tooltip_description: 'dispatch_short_tooltip',
//     full_tooltip_description: 'dispatch_full_tooltip',
//     navbar_name: 'dispatch_navbar',
//     background_color: 'blue',
//   },
//   output: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-file', 'text-blue'],
//     front_classes: ['fas', 'fa-arrow-alt-up', 'text-white'],
//     name: 'output',
//     associated_class_name: 'AutomlDummy',
//     short_tooltip_description: 'output_short_tooltip',
//     full_tooltip_description: 'output_full_tooltip',
//     navbar_name: 'output_navbar',
//     background_color: 'blue',
//   },
//   modelgen: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-certificate', 'text-purple'],
//     front_classes: ['fas', 'fa-tree-alt', 'text-white'],
//     name: 'modelgen',
//     editing_component: 'BrickGenericModelgenerator',
//     summary_component: 'SummaryModel',
//     associated_class_name: 'AutomlGenericModelgenerator',
//     short_tooltip_description: 'modelgen_short_tooltip',
//     full_tooltip_description: 'modelgen_full_tooltip',
//     navbar_name: 'modelgen_navbar',
//     background_color: 'purple',
//   },
//   result: {
//     input: ' > ',
//     output: ' > ',
//     back_classes: ['fas', 'fa-download', 'text-green'],
//     front_classes: ['fas', 'fa-download', 'text-white'],
//     name: 'result',
//     summary_component: 'SummaryResult',
//     editing_component: 'BrickResult',
//     associated_class_name: 'AutomlResult',
//     short_tooltip_description: 'result_short_tooltip',
//     full_tooltip_description: 'result_full_tooltip',
//     navbar_name: 'result_navbar',
//     background_color: 'green',
//   },
//   finish: {
//     input: ' > ',
//     output: '   ',
//     back_classes: ['fas', 'fa-rectangle-landscape', 'text-darkgrey'],
//     front_classes: ['fas', 'fa-flag-checkered', 'text-white'],
//     name: 'finish',
//     editing_component: 'BrickFinish',
//     associated_class_name: 'AutomlFinish',
//     short_tooltip_description: 'finish_short_tooltip',
//     full_tooltip_description: 'finish_full_tooltip',
//     navbar_name: 'finish_navbar',
//     background_color: 'darkgrey',
//   },
// }

// export function color_from_name(name) {
//   return corr[name].background_color
// }

// export function definition_from_name(name) {
//   return corr[name]
// }

// export function short_tooltip_description_from_name(name) {
//   return corr[name].short_tooltip_description
// }

// export function full_tooltip_description_from_name(name) {
//   return corr[name].full_tooltip_description
// }

// export function icon_from_name(name, selection = 0) {
//   return create_icons(definition_from_name(name), selection)
// }

// export function brick_creator_from_name(name) {
//   return _.snakeCase(corr[name].associated_class_name)
// }

// export function editing_component_from_name(name) {
//   return (corr[name] || {}).editing_component
// }

// export function summary_component_from_name(name) {
//   return (corr[name] || {}).summary_component
// }
export function color_from_name(name) {
  return brick_info_from_name(name).background_color
}

export function definition_from_name(name) {
  return brick_info_from_name(name)
}

// export function short_tooltip_description_from_name(name) {
//   return brick_info_from_name(name).short_tooltip_description
// }

// export function full_tooltip_description_from_name(name) {
//   return brick_info_from_name(name).full_tooltip_description
// }

export function short_tooltip_description_from_name(name) {
  let res
  if (name != 'none') {
    res = i18n.t(brick_info_from_name(name).name + '_short_tooltip')
  } else {
    res = ''
  }
  return res
}

export function full_tooltip_description_from_name(name) {
  let res
  if (name != 'none') {
    res = i18n.t(brick_info_from_name(name).name + '_full_tooltip')
  } else {
    res = ''
  }
  return res
}
export function navbar_from_name(name) {
  let res
  if (name != 'none') {
    res = i18n.t(brick_info_from_name(name).name + '_navbar')
  } else {
    res = ''
  }
  return res
}

export function icon_from_name(name, selection = 0) {
  return create_icons(definition_from_name(name), selection)
}

export function brick_creator_from_name(name) {
  return _.snakeCase(brick_info_from_name(name).associated_class_name)
}

export function editing_component_from_name(name) {
  return (brick_info_from_name(name) || {}).editing_component_name
}

export function summary_component_from_name(name) {
  return (brick_info_from_name(name) || {}).summary_component_name
}

export function element_preview_type_from_name(name) {
  return (brick_info_from_name(name) || {}).element_preview_type
}

export class SVGArrowDrawerBase {
  constructor(holding_div, use_clickline) {
    this.holding_div = holding_div
    this.use_clickline = use_clickline

    this.click_handler = undefined

    holding_div.style = `position: absolute;overflow: hidden;`

    let canvas = SVG(holding_div)
      .size('0px', '0px')
      .viewbox(0, 0, 0, 0)
    this.canvas = canvas
    let defs = canvas.defs()

    // Hard coded arrow start
    defs
      .marker(6, 9, function(add) {
        add.path('M9,0 L9,6 L0,3 z').attr({ fill: '#6ec6ff' })
      })
      .attr({
        markerWidth: '10',
        markerHeight: '10',
        markerUnits: 'strokeWidth',
      })
      .ref(0, 3)

    // Hard coded arrow stop
    defs
      .marker(6, 9, function(add) {
        add.path('M0,0 L0,6 L9,3 z').attr({ fill: '#6ec6ff' })
      })
      .attr({
        markerWidth: '10',
        markerHeight: '10',
        markerUnits: 'strokeWidth',
      })
      .ref(9, 3)

    // Hidden additional line for a larger click area
    if (this.use_clickline) {
      let clickline = canvas
        .line(0, 0, 0, 0)
        .attr({ 'stroke-width': '8px', style: 'visibility: hidden;' })
      this.clickline = clickline
    }
    // Colored displayed line
    let line = canvas
      .line(0, 0, 0, 0)
      .attr({ 'stroke-width': '2px', stroke: '#6ec6ff' })
    this.line = line

    // Adds a marker at the end of the line
    // line.marker('end', end_marker)
    this.border = 16
  }

  set_line_color(color) {
    this.line.attr({ stroke: color })
  }

  update(coords) {
    if (_.isUndefined(coords)) {
      return
    }
    const { from, to } = coords
    let { x: startx, y: starty } = from
    let { x: stopx, y: stopy } = to
    let minx = Math.min(startx, stopx)
    let maxx = Math.max(startx, stopx)
    let miny = Math.min(starty, stopy)
    let maxy = Math.max(starty, stopy)

    let holding_div_style = this.holding_div.style
    const border = this.border

    let box_width = maxx - minx + 2 * border
    let box_height = maxy - miny + 2 * border
    let box_minx = minx - border
    let box_miny = miny - border

    holding_div_style.width = `${box_width}px`
    holding_div_style.height = `${box_height}px`
    holding_div_style.transform = `translate(${box_minx}px, ${box_miny}px)`

    this.canvas.size(`${box_width}px`, `${box_height}px`)
    this.canvas.viewbox(0, 0, box_width, box_height)

    let rel_startx = startx - minx + border
    let rel_starty = starty - miny + border
    let rel_stopx = stopx - minx + border
    let rel_stopy = stopy - miny + border

    if (this.use_clickline) {
      this.clickline.plot(rel_startx, rel_starty, rel_stopx, rel_stopy)
    }
    this.line.plot(rel_startx, rel_starty, rel_stopx, rel_stopy)
  }

  on_click(handler) {
    if (handler === this.handler) {
      return
    }
    if (_.isUndefined(handler)) {
      console.assert(!_.isUndefined(this.handler))
      if (this.use_clickline) {
        this.clickline.off('click', this.handler)
      }
      this.line.off('click', this.handler)
      this.handler = undefined
    } else {
      console.assert(_.isUndefined(this.handler))
      this.handler = handler
      if (this.use_clickline) {
        this.clickline.on('click', this.handler)
      }
      this.line.on('click', this.handler)
    }
  }

  stop() {
    this.on_click(undefined)
    if (this.use_clickline) {
      this.clickline.off()
    }
    this.line.off()
  }
}

export function polygon_from_box(box) {
  let poly = new Polygon()
  poly.addFace([
    point(box.xmin, box.ymin),
    point(box.xmin, box.ymax),
    point(box.xmax, box.ymax),
    point(box.xmax, box.ymin),
  ])
  return poly
}

export const disabled_brick_types = ''.split(' ')

export function scale_from_scale_index(scale_index) {
  const zooms = [
    1 / 5,
    1 / 4,
    1 / 2,
    2 / 3,
    3 / 4,
    4 / 5,
    9 / 10,
    1,
    11 / 10,
    5 / 4,
    3 / 2,
    7 / 4,
    2,
    5 / 2,
    3,
    4,
    5,
  ]
  let scale
  const offseted_scale_index = scale_index + 7
  if (offseted_scale_index >= zooms.length) {
    const start = zooms[zooms.length - 1]
    const diff = offseted_scale_index - zooms.length + 1
    scale = start * Math.pow(1.1, diff)
  } else if (offseted_scale_index < 0) {
    const start = zooms[0]
    const diff = offseted_scale_index
    scale = start * Math.pow(1.1, diff)
  } else {
    scale = zooms[offseted_scale_index]
  }
  return scale
}
